import React from 'react'
import { useTranslation } from 'react-i18next'
import useAccess from '../../../utils/hooks/useAccess'
import { NotificationsService } from '../../../services/purchase-fuel/notifications/notifications.service'
import NotificationsCommonView from '../../../components/common/notifications-module/NotificationsCommonView'
import { GROUPS, MODULES } from '../../../utils/constants/roles'
import AppSection from '../../../component/layout/AppSection.tsx'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import { purchaseFuels } from '../../../utils/constants/navlinks-Menu'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'

const Notifications = () => {
  const { t } = useTranslation()

  const { canAdd, canDelete } = useAccess()

  return (
    <AppSection
      /* refactor this */
      header={<AppTabMenu options={purchaseFuels} breakpoint="xl" />}
      subheader={<AppToolbar leftSection={t('notifications')} />}
    >
      <NotificationsCommonView
        getAllNotificationModules={NotificationsService.getAllModuleUsers}
        canDeleteUser={canDelete(MODULES.PURCHASE_FUEL, GROUPS.NOTIFICATION)}
        removeUserNotificationModuleService={NotificationsService.removeUser}
        canAddUser={canAdd(MODULES.PURCHASE_FUEL, GROUPS.NOTIFICATION)}
        addUserNotificationModuleService={NotificationsService.addUser}
      />
    </AppSection>
  )
}

export default Notifications
